import MojitoServices from 'mojito/services';

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const {FILTER_CRITERIA_TYPE} = MojitoServices.Bets.types;

export function getBetHistoryConfig() {
    const CUSTOM_CONFIG = {
        BetHistoryView: {
            filters: {
                defaultRangeFilter: {
                    options: {
                        value: 'today',
                        duration: 1,
                        timeSpan: 'today',
                    },
                    type: FILTER_CRITERIA_TYPE.TIME_FRAME,
                },
            },
        },
        BetHistoryDetails: {
            hidePdfButton: true,
        },
    };

    return {
        custom: {
            [PALETTE_IDS.BET_HISTORY]: CUSTOM_CONFIG,
        },
        palette: {
            [PALETTE_IDS.BET_HISTORY]: {
                BET_HISTORY_TABLE: {
                    TABLE_HEADER_BG: COLOR.BRAND.FOREGROUND2,
                    TABLE_ITEM_SELECTED_BG: COLOR.BRAND.BACKGROUND3,
                    TABLE_HEADER_TEXT: COLOR.BRAND.FOREGROUND6,
                },
                BET_HISTORY_DETAILS_BET_BASE_INFO: {
                    BET_EVENT_NAME_TEXT: {
                        fontWeight: FONT.WEIGHT_SEMI_BOLD,
                        color: COLOR.BRAND.FOREGROUND2,
                    },
                },
                BET_HISTORY_DETAILS_RECEIPT_INFO_TEXT: COLOR.BRAND.FOREGROUND2,
                BET_HISTORY_DETAILS_LEGS_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_SEMI_BOLD,
                    textTransform: 'capitalize',
                },
            },
        },
    };
}
